import { useEffect, useState } from "react"
import Grade from "./grade"
import { PropTypes } from 'prop-types';
import { useSearchParams } from "react-router-dom";

const Secondary = ({ handleAllowNext }) => {
    const button1 = `SPM`
    const button2 = `O-Level`

    const [searchParams, setSearchParams] = useSearchParams()

    const [qualification, setQualification] = useState(-1)
    const [grade, setGrade] = useState({
        A: 0,
        B: 0,
        C: 0,
        D: 0,
        E: 0,
        F: 0
    })

    useEffect(() => {
        console.log(grade)
        // print only key with value whose value is greater than 0
        let result = Object.keys(grade).filter(key => grade[key] > 0)
        let str = result.map(r => `${grade[r]}${[r]}`).join()
        if (str != "") {
            setSearchParams(searchParams => {
                searchParams.set("educationResult", str);
                return searchParams;
            });
        }
        else {
            setSearchParams(searchParams => {
                searchParams.delete("educationResult");
                return searchParams;
            });
        }

    }, [grade])

    const handleQualification = (qualification) => {
        setQualification(qualification)
        handleAllowNext()
        setSearchParams(searchParams => {
            searchParams.set("educationType", "spm");
            return searchParams;
        });
    }
    return (

        <div className="flex flex-col gap-5">
            <h2 className="text-xl font-semibold">What is the qualification ?</h2>
            <div className="flex flex-col md:flex-row gap-3 max-w-md">
                <button onClick={() => handleQualification(0)} className={`flex-1 ${qualification === 0 ? "bg-[#367AB1] text-white" : "bg-white "} transition-all border border-gray-200 p-4 rounded-lg whitespace-pre-line`}>{button1}
                </button>
                <button onClick={() => handleQualification(1)} className={`flex-1 ${qualification === 1 ? "bg-[#367AB1] text-white" : "bg-white "} transition-all border border-gray-200 p-4 rounded-lg whitespace-pre-line`}>{button2}</button>
            </div>

            <div className="flex flex-col gap-5 relative">
                {
                    qualification === -1 &&
                    <div className="absolute top-0 left-0 w-full h-full bg-white bg-opacity-60 flex items-center justify-center" />
                }


                <h2 className="text-xl font-semibold">What is your results ?</h2>
                <div className="flex flex-col md:flex-row gap-3 ">
                    <div className="w-full flex-1 flex flex-col gap-8">
                        <Grade title="A*/A+" setGrade={(e) => setGrade(prev => ({ ...prev, A: e }))} />
                        <Grade title="B*/B+" setGrade={(e) => setGrade(prev => ({ ...prev, B: e }))} />
                        <Grade title="C*/C+" setGrade={(e) => setGrade(prev => ({ ...prev, C: e }))} />
                    </div>
                    <div className="w-full flex-1 flex flex-col gap-8">
                        <Grade title="D*/D+" setGrade={(e) => setGrade(prev => ({ ...prev, D: e }))} />
                        <Grade title="E*/E+" setGrade={(e) => setGrade(prev => ({ ...prev, E: e }))} />
                        <Grade title="F*/F+" setGrade={(e) => setGrade(prev => ({ ...prev, F: e }))} />
                    </div>
                </div>
            </div>

        </div>
    )
}
Secondary.propTypes = {
    handleAllowNext: PropTypes.any
}
export default Secondary